/**
 * Internal dependencies
 */
import { setNavBarOffset } from '../actions';
import { Reducer } from '../types';
import isAction from '../isAction';
import initialState from '../initialState';

const navBarOffset: Reducer<number> = (
	state = initialState.navBarOffset,
	action
) => (isAction(action, setNavBarOffset) ? action.payload : state);

export default navBarOffset;
